import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonStyle, ButtonSize, ButtonSpacing } from '../buttons/button.type';

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit {
  @Input() options: { label: string; value: string }[] = [];
  @Input() selectedValue: string = '';
  @Input() isDisabled: boolean = false;
  @Input() isDefaultDisabled: boolean = true;
  @Input() style: ButtonStyle = ButtonStyle.Outlined;
  @Input() size: ButtonSize = ButtonSize.Medium;
  @Input() spacing: ButtonSpacing = ButtonSpacing.FitContent;
  @Input() state: string = '';
  @Input() getStateClass: (value: string) => string = () => 'empty';

  @Output() valueChange = new EventEmitter<string>();

  stateClass: string = this.getStateClass!(this.selectedValue);

  ngOnInit(): void {
    this.stateClass = this.getStateClass(this.selectedValue);
  }

  onChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.stateClass = this.getStateClass(value);
    this.valueChange.emit(value);
  }
}
